import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import RequestAccess from './views/RequestAccess.vue'
import NewUserRequest from './views/NewUserRequest.vue'
import ContactUs from './views/ContactUs.vue'
import IntroPage from './views/IntroPage.vue'
import ReportIssue from './views/ReportIssue.vue'
import DataReport from './views/DataReport.vue'

import AddTask from './views/AddTask.vue'
import UpdateTask from './views/UpdateTask.vue'
import ViewTask from './views/ViewTask.vue'

import LLPHelp from './components/LLPHelp.vue'
import AddEmployee from './views/AddEmployee.vue'
import ViewUpdateEmployee from './views/ViewUpdateEmployee.vue'

import AddCustomer from './views/AddCustomer.vue'
import ViewUpdateCustomer from './views/ViewUpdateCustomer.vue'

import AddDealer from './views/AddDealer.vue'
import UpdateDealer from './views/UpdateDealer.vue'
import ViewUpdateDealer from './views/ViewUpdateDealer.vue'
import ManageInHouse from './views/ManageInHouse.vue'

import Yodlee from './components/Yodlee.vue'

import ScheduleActivity from './views/ScheduleActivity.vue'
import ViewActivity from './views/ViewActivity.vue'
import ManageMileage from './views/ManageMileage.vue'
import AddActivity from './views/AddActivity.vue'

import ViewDashboard from './views/ViewDashboard.vue'
import ViewScorecard from './views/ViewScorecard.vue'
import ViewAssignments from './views/ViewAssignments.vue'
import AssignedDealers from './views/AssignedDealers.vue'

import GenerateQuote from './views/GenerateQuote.vue'
import EditQuote from './views/EditQuote.vue'
import AddApplication from './views/AddApplication.vue'
import ReviewApplication from './views/ReviewApplication.vue'
import ConvertAppToDeal from './views/ConvertAppToDeal.vue'
import ViewDeals from './views/ViewDeals.vue'
import manageEmployee from './views/ManageEmployee.vue'
import ViewAgentTaskNotes from './views/ViewAgentTaskNotes.vue'
import QuoteGeneration from './components/QuoteGeneration.vue'
import ReviewQuote from './components/ReviewQuote.vue'
import AdminCorporate from './components/AdminCorporate.vue'
import collateralPrice from './views/CollateralPrice.vue'
import Dashboard from './views/Dashboard.vue'
import PayOff from './views/PayOff.vue'
import CustomerFraudHistory from './views/CustomerFraudAudit.vue'
import CustomerUniversalSearch from './views/CustomerUniversalSearch.vue'
import DMVTitle from './views/DmvTitle.vue'
import Contact from './views/Contact.vue'
import salesPropertyTax from './views/reporting/SalesPropertyTax.vue'
import VinBlacklist from './views/VinBlacklist.vue';
import MergeCustomerData from './views/MergeCustomerData.vue'
import MergedCustomersList from './views/MergedCustomersList.vue'
import CustomerActivityLog from './views/CustomerActivityLog.vue'
import MergeDealerData from './views/MergeDealerData.vue'
import MergedDealersList from './views/MergedDealersList.vue'
import DealerActivityLog from './views/DealerActivityLog.vue'
import RoleManagement from './views/RoleManagement.vue'
import AddNewRole from './views/AddNewRole.vue'
import AddVin from './views/AddVin.vue'
import AddEditRole from './views/AddEditRole.vue'
import RolePermissions from './views/RolePermissions.vue'
import UserManagement from './views/UserManagement.vue'
import UserPermissions from './views/UserPermissions.vue'
import UnAuthorize from './views/UnAuthorize.vue'
import MmrList from './views/MmrList.vue'
import AciAnalysis from './views/AciAnalysis.vue'
import DailyMasterScript from './views/DailyMasterScript.vue'

Vue.use(Router)

function hasAccess(path) {
  const permissions = JSON.parse(localStorage.getItem('userPermissions'))
  if (!permissions) {
    return false
  }
  return permissions.some(permission => {
    if (permission.componentName !== null && permission.access) {
      return (permission.componentName === path) 
    } else {
      return permission.subMenu.some(subMenu => {
        if (subMenu.componentName !== null) {
          return subMenu.componentName === path && subMenu.access
        } else {
          return subMenu.subMenu.some(subSubMenu => {
            return subSubMenu.componentName === path && subSubMenu.access
          })
        }
       
      })
    }
  } 
)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'IntroPage',
      component: IntroPage
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/forgot',
      component: ForgotPassword,
      name: 'forgot'
    },
    { path: '/contactUs', component: ContactUs, name: 'contactUs' },
    {
      path: '/requestAccess',
      component: RequestAccess,
      name: 'requestAccess',
      meta: { requiresAuth: true, authName: 'requestAccess' }
    },

    {
      path: '/addEmployee',
      component: AddEmployee,
      name: 'addEmployee',
      meta: { requiresAuth: true, authName: 'addEmployee' }
    },
    {
      path: '/viewEmployee',
      component: ViewUpdateEmployee,
      name: 'viewUpdateEmployee',
      meta: { requiresAuth: true, authName: 'viewEmployee' }
    },

    {
      path: '/addCustomer',
      component: AddCustomer,
      name: 'addCustomer',
      meta: { requiresAuth: true, authName: 'addCustomer' }
    },
    {
      path: '/viewUpdateCustomer',
      component: ViewUpdateCustomer,
      name: 'viewUpdateCustomer',
      meta: { requiresAuth: true, authName: 'viewUpdateCustomer' }
    },
    {
      path: '/mergeCustomers',
      component: MergeCustomerData,
      name: 'mergeCustomerData',
      meta: { requiresAuth: true, authName: 'mergeCustomers' }
    },
    {
      path: '/mergedCustomersList',
      component: MergedCustomersList,
      name: 'mergedCustomersList',
      meta: { requiresAuth: true, authName: 'mergeCustomers' }
    },
    {
      path: '/customerActivityLog',
      component: CustomerActivityLog,
      name: 'customerActivityLog',
      meta: { requiresAuth: true, authName: 'mergeCustomers' }
    },

    {
      path: '/addDealer',
      component: AddDealer,
      name: 'addDealer',
      meta: { requiresAuth: true, authName: 'addDealer' }
    },
    {
      path: '/updateDealer',
      component: UpdateDealer,
      name: 'updateDealer',
      meta: { requiresAuth: true, authName: 'updateDealer' }
    },
    {
      path: '/viewDealer',
      component: ViewUpdateDealer,
      name: 'viewUpdateDealer',
      meta: { requiresAuth: true, authName: 'viewDealer' }
    },
    {
      path: '/mergeDealer',
      component: MergeDealerData,
      name: 'mergeDealerData',
      meta: { requiresAuth: true, authName: 'mergeDealer' }
    },
    {
      path: '/mergedDealersList',
      component: MergedDealersList,
      name: 'mergedDealersList',
      meta: { requiresAuth: true, authName: 'mergeDealer' }
    },
    {
      path: '/dealerActivityLog',
      component: DealerActivityLog,
      name: 'dealerActivityLog',
      meta: { requiresAuth: true, authName: 'mergeDealer' }
    },
    {
      path: '/manageInhouse',
      component: ManageInHouse,
      name: 'manageInHouse',
      meta: { requiresAuth: true, authName: 'manageInhouse' }
    },

    {
      path: '/scheduleActivity',
      component: ScheduleActivity,
      name: 'scheduleActivity',
      meta: { requiresAuth: true, authName: 'scheduleActivity' }
    },
    {
      path: '/viewActivity',
      component: ViewActivity,
      name: 'viewActivity',
      meta: { requiresAuth: true, authName: 'viewActivity' }
    },
    {
      path: '/manageMilege',
      component: ManageMileage,
      name: 'manageMileage',
      meta: { requiresAuth: true, authName: 'manageMilege' }
    },
    {
      path: '/addActivity',
      component: AddActivity,
      name: 'addActivity',
      meta: { requiresAuth: true, authName: 'addActivity' }
    },

    {
      path: '/viewDashboard',
      component: ViewDashboard,
      name: 'viewDashboard',
      meta: { requiresAuth: true, authName: 'viewDashboard' }
    },
    {
      path: '/viewScorecard',
      component: ViewScorecard,
      name: 'viewScorecard',
      meta: { requiresAuth: true, authName: 'viewScorecard' }
    },
    {
      path: '/viewAssignments',
      component: ViewAssignments,
      name: 'viewAssignments',
      meta: { requiresAuth: true, authName: 'viewAssignments' }
    },

    {
      path: '/generateQuote',
      component: GenerateQuote,
      name: 'generateQuote',
      meta: { requiresAuth: true, authName: 'generateQuote' }
    },
    {
      path: '/editQuote',
      component: EditQuote,
      name: 'editQuote',
      meta: { requiresAuth: true, authName: 'editQuote' }
    },
    {
      path: '/addApplication',
      component: AddApplication,
      name: 'addApplication',
      meta: { requiresAuth: true, authName: 'addApplication' }
    },
    {
      path: '/reviewApplication',
      component: ReviewApplication,
      name: 'reviewApplication',
      meta: { requiresAuth: true, authName: 'reviewApplication' }
    },
    {
      path: '/customerUniversalSearch',
      component: CustomerUniversalSearch,
      name: 'customeruniversalsearch',
      meta: { requiresAuth: true, authName: 'customerUniversalSearch' }
    },
    {
      path: '/convertAppToDeal',
      component: ConvertAppToDeal,
      name: 'convertAppToDeal',
      meta: { requiresAuth: true, authName: 'convertAppToDeal' }
    },
    {
      path: '/viewDeals',
      component: ViewDeals,
      name: 'viewDeals',
      meta: { requiresAuth: true, authName: 'viewDeals' }
    },
    {
      path: '/profile',
      component: manageEmployee,
      name: 'manageEmployee',
    },
    {
      path: '/help',
      component: LLPHelp,
      name: 'llpHelp',
      // meta: { requiresAuth: true, authName: 'help' }
    },
    {
      path: '/yodlee',
      component: Yodlee,
      name: 'yodlee',
      meta: { requiresAuth: true, authName: 'yodlee' }
    },
    {
      path: '/addTask',
      component: AddTask,
      name: 'addTask',
      meta: { requiresAuth: true, authName: 'addTask' }
    },
    {
      path: '/viewTask',
      component: ViewTask,
      name: 'viewTask',
      meta: { requiresAuth: true, authName: 'viewTask' }
    },
    {
      path: '/updateTask',
      component: UpdateTask,
      name: 'updateTask',
      meta: { requiresAuth: true, authName: 'updateTask' }
    },
    {
      path: '/newuserregister',
      component: NewUserRequest,
      name: 'newuserregister',
      meta: { requiresAuth: true, authName: 'newuserregister' }
    },
    {
      path: '/salespersonTaskNotes',
      component: ViewAgentTaskNotes,
      name: 'viewagentasknotes',
      meta: { requiresAuth: true, authName: 'salespersonTaskNotes' }
    },
    {
      path: '/assignedDealers',
      component: AssignedDealers,
      name: 'assignedDealers',
      meta: { requiresAuth: true, authName: 'assignedDealers' }
    },
    {
      path: '/reportAnIssue',
      component: ReportIssue,
      name: 'reportissue',
      meta: { requiresAuth: true, authName: 'reportAnIssue' }
    },
    {
      path: '/dataReport',
      component: DataReport,
      name: 'datareport',
      meta: { requiresAuth: true, authName: 'dataReport' }
    },
    {
      path: '/quoteGeneration',
      component: QuoteGeneration,
      name: 'QuoteGeneration',
      meta: { requiresAuth: true, authName: 'quoteGeneration' }
    },
    {
      path: '/reviewQuote',
      component: ReviewQuote,
      name: 'ReviewQuote',
      meta: { requiresAuth: true, authName: 'reviewQuote' }
    },
    {
      path: '/adminCorporate',
      component: AdminCorporate,
      name: 'AdminCorporate',
      meta: { requiresAuth: true, authName: 'adminCorporate' }
    },
    {
      path: '/payoffQuote',
      component: PayOff,
      name: 'payoff',
      // meta: { requiresAuth: true, authName: 'payoffQuote' }
    },
    {
      path: '/mmr',
      component: MmrList,
      name: 'mmr',
      meta: { requiresAuth: true, authName: 'mmr' }
    },
    {
      path: '/dashboardReporting',
      component: Dashboard,
      name: 'dashboard',
      meta: { requiresAuth: true, authName: 'dashboardReporting' }
    },
    {
      path: '/customerAuditHistory',
      component: CustomerFraudHistory,
      name: 'customerFraudHistory',
      meta: { requiresAuth: true, authName: 'customerAuditHistory' }
    },

    {
      path: '/automatedQuoteTool',
      component: collateralPrice,
      name: 'collateralPrice',
      meta: { requiresAuth: true, authName: 'automatedQuoteTool' }
    },

    {
      path: '/dmvTitle',
      component: DMVTitle,
      name: 'dmvtitle',
      meta: { requiresAuth: true, authName: 'dmvTitle' }
    },

    {
      path: '/contact',
      component: Contact,
      name: 'contact',
      meta: { requiresAuth: true, authName: 'contact' }
    },
    {
      path: '/salesPropertyTax',
      component: salesPropertyTax,
      name: 'salesPropertyTax',
      meta: { requiresAuth: true, authName: 'salesPropertyTax' }
    },
    {
      path: '/blacklistVin',
      component: VinBlacklist,
      name: 'vinBlacklist',
      meta: { requiresAuth: true, authName: 'blacklistVin' }
    },
    {
      path: '/addVin',
      component: AddVin,
      name: 'addVin',
      meta: { requiresAuth: true, authName: 'addVin' }
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
      // meta: { requiresAuth: true }
    },
    {
      path: '/roleManagement',
      component: RoleManagement,
      name: 'roleManagement',
      meta: { requiresAuth: true, authName: 'roleManagement' }
    },
    {
      path: '/rolePermissions/:roleId',
      component: RolePermissions,
      name: 'rolePermissions'
      
    },
    {
      path: '/addNewRole',
      component: AddEditRole,
      name: 'addEditRole'
    },
    {
      path: '/editRole/:roleId',
      component: AddEditRole,
      name: 'editRole'
    },
    {
      path: '/userManagement',
      component: UserManagement,
      name: 'userManagement',
      meta: { requiresAuth: true, authName: 'userManagement' }
    },
    {
      path: '/userPermissions/:userId',
      component: UserPermissions,
      name: 'userPermissions'
    },
    {
      path: '/aci',
      component: AciAnalysis,
      name: 'aciAnalysis',
      meta: { requiresAuth: true, authName: 'aci' }
    },
    {
      path: '/dailyMasterScripts',
      component: DailyMasterScript,
      name: 'dailyMasterScript',
      meta: { requiresAuth: true, authName: 'dailyMasterScripts' }
    },
    {
      path: '/unauthorized',
      component: UnAuthorize,
      name: 'unAuthorize'
    }
  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // const pathWithoutSlash = to.path.startsWith('/') ? to.path.substring(1) : to.path;
    const matchedRecord = to.matched.find(record => record.meta.authName);
    const authName = matchedRecord ? matchedRecord.meta.authName : to.path.substring(1);
    if (hasAccess(authName)) {
      next();
    } else {
      next('/unauthorized'); // Redirect to an unauthorized page or any other route
    }
  } else {
    next(); // Always call next() to proceed to the route
  }
});

export default router;
